module.exports = __webpack_public_path__ + "img/front.f8215cea.png";